











































































import { Vue, Component } from "vue-property-decorator";
import { Calendar, Popup, Overlay, Dialog } from "vant";
// import productDetails from "../modules/productDetails.vue";
import bottonBar from "@/components/bottonBar.vue";
import amendRule from "./amendRule.vue";
import dataShare from "../dataShare";
import _ from "lodash";
import { YesOrNo } from "@/model/Base";
import session from "@/utils/session";
import { dateDiff } from "@/utils/utils.ts";
import SystemService from "@/service/UserService";
import trainService from "@/service/trainService";

@Component({
  name: "trainInfo",
  components: {
    [Calendar.name]: Calendar,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
    bottonBar,
    amendRule,
  },
  methods: { dateDiff },
})
export default class extends Vue {
  flightDetailList = [];
  detailList: any = {};

  isShowCalendar = false;
  isRoundTrip = false;
  startTime: any = "";
  isShowRule = false;
  date = new Date();

  get product(): object {
    return this.$route.query;
  }

  get ServeType() {
    return this.$route.query.ServeType;
  }
  get trainProductDetail() {
    return this.detailList;
  }
  get Seats() {
    let seats = this.detailList.Seats;
    seats = _.sortBy(seats, o => o.fare);
    return seats;
  }
  get isDisabledReserve() {
    return !this.$route.query.approvalCode && this.disabledReserve;
  }

  back() {
    history.back();
  }
  //mounted
  mounted() {
    (this.detailList as any) = dataShare.ProductDetails;
    this.startTime = (this as any).detailList.start_time;
    this.getApprovalExtra();
    this.checkPaymentAvailable();
  }
  //methods
  showCalende() {
    this.isShowCalendar = true;
  }
  handleSelect(time: Date) {
    this.startTime = time;
    this.isShowCalendar = false;
  }
  handleUpDay(date: string) {
    const newDate = (this as any).$moment(date).format("YYYY-MM-DD");
    this.date = (this as any)
      .$moment(newDate)
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    this.startTime = (this as any)
      .$moment(newDate)
      .subtract(1, "days")
      .format("MM-DD ddd");
  }
  handleDownDay(date: string) {
    const newDate = (this as any).$moment(date).format("YYYY-MM-DD");
    this.date = (this as any)
      .$moment(newDate)
      .add(1, "days")
      .format("YYYY-MM-DD");
    this.startTime = (this as any)
      .$moment(newDate)
      .add(1, "days")
      .format("MM-DD ddd");
  }
  contraryTips(seat: any) {
    return seat && seat.ContraryInfo && seat.ContraryInfo.join(",");
  }
  showContraryTips(seat: any) {
    this.$root.$toast(`${this.$root.$t("mall_train_traindetails_weibei")}${this.contraryTips(seat)}`);
  }
  gotoOrder(detail: any, list: any) {
    const query = this.$route.query;
    const value: any = {
      ServiceType: "1470",
      ProductId: list.ProductID,
      seatType: detail.type,
      DepartCityCode: list.from_station_code,
      ArriveCityCode: list.to_station_code,
      DepartDate: list.train_start_date,
      trainCode: list.train_code,
      Consumers: query.Consumers,
      BookingType: query.BookingType,
      ApplyArea: query.ApplyArea,
      RuleType: query.RuleType,
      UniqueID: "",
      approvalCode:query.approvalCode
    };
    if (query.UniqueID) {
      const OldProducts = dataShare.changeSource as any;
      value.UniqueID = query.UniqueID;
      this.$router.push({
        path: `/mall/train/ChangeInfos`,
        query: value,
      });
      return;
    }
    this.$router.push({
      path: "/mall/train/order",
      query: value,
    });
  }
  // 不可预定
  noBooking(value: any) {
    if (value.num > 0) {
      return this.$toast.fail("违背政策不可预定！");
    }
    return this.$toast.fail("座席无余票！");
  }
  //隐藏违背政策的产品
  get FeatureCodes() {
    return this.$route.query.FeatureCodes || "";
  }
  get isHideOverproof() {
    return this.FeatureCodes.indexOf("HideProduct") > -1;
  }
  get isForbidViolate(){
    return this.FeatureCodes.indexOf("ForbidViolate") > -1;
  }
  isAllContrary() {
    let goods = this.Seats.filter((o: any) => o.IsContrary == YesOrNo.No);
    return !goods || goods.length <= 0;
  }

  isShowGood(good: any, index: number) {

    //差旅政策规定 隐藏违背政策的产品 违背政策的商品 且 不是第一条
    // if (this.isHideOverproof && good.IsContrary == YesOrNo.Yes && index > 0) {
    if (this.isHideOverproof && good.IsContrary == YesOrNo.Yes) {
      if(this.isAllContrary()&&index==0){
        return true;
      }
      return false;
    }
    return true;
  }
  isCanBooking(good: any, index: number) {
    //差旅政策规定 隐藏违背政策的产品 违背政策的商品 且 不是第一条
    // if (this.isHideOverproof && good.IsContrary == YesOrNo.Yes && index > 0) {
    if ((this.isHideOverproof || this.isForbidViolate) && good.IsContrary == YesOrNo.Yes) {
      return false;
    }
    return true;
  }

  isStartStation() {
    let trainData = this.detailList || dataShare.ProductDetails;
    if (trainData.start_station_name == trainData.from_station_name) {
      return this.$root.$t("mall_order_shifa");
    }
    return this.$root.$t("mall_order_jingting");
  }
  disabledReserve:boolean = false;
  paymentAvailable:boolean = true;
  paymentErrorMessage:string = '';
  getApprovalExtra(){
    let __self=this;
    let data={
      ExtraCode:'company.ApprovalInfoSetting',
      MasterID:__self.profile.CompanyID || ''
    };
    SystemService.getCompanyExtra(data).then(p=>{
      if(p.isSucc){
        const data=p.result;
        if(data && data.ExtraData){
          __self.disabledReserve=data.ExtraData.indexOf('selectApprovalBooking')>-1 || false;
        }
      }
    })
  }
  checkPaymentAvailable(){
    let __self = this;
    // 先调用 getRoleInfo 获取联系方式
    SystemService.getRoleInfo({ RoleID: this.profile.UserID })
      .then((res: any) => {
        if (!res.isSucc || !res.result || !res.result.ContactInfo) {
          return;
        }
        const contactInfo = res.result.ContactInfo;
        const contactName = this.profile.UserName;
        const contactPhone = contactInfo.ContactPhone;

        if (!contactName || !contactPhone) {
          return;
        }

        // 调用检查支付可用性接口
        trainService
          .CheckPaymentAvailable(contactName, contactPhone)
          .then((certRes: any) => {
            if (certRes.isSucc) {
              __self.paymentAvailable = true;
              __self.paymentErrorMessage = '';
            } else {
              __self.paymentAvailable = false;
              __self.paymentErrorMessage = certRes.message || '支付服务不可用';
            }
          })
          .catch(() => {
            __self.paymentAvailable = false;
            __self.paymentErrorMessage = '支付服务检查失败';
          });
      })
      .catch(() => {
        __self.paymentAvailable = false;
        __self.paymentErrorMessage = '用户信息获取失败';
      });
  }
  showHint(){
    Dialog.alert({
      title: "温馨提示",
      message: "请选择审批单进行预定！",
      confirmButtonText: "我已知晓",
    }).then(() => {
    });
  }
  showPaymentError(){
    Dialog.alert({
      title: "温馨提示",
      message: this.paymentErrorMessage || '支付服务不可用',
      confirmButtonText: "我已知晓",
    }).then(() => {
    });
  }
}
